/**
 * The site answers on both `collectagift.com` and `www.collectagift.com`, but a sign-in is kept per
 * address, so being on one and coming back to the other (from Stripe, or from a link in an e-mail,
 * which always name `www`) looks like being signed out. Everyone is kept on one address instead.
 *
 * Returns the address to move to, or null when the page is already on the right one (or no address
 * is configured, as on a developer's computer).
 */
export function canonicalUrl(
  canonicalHost: string | undefined,
  here: Pick<Location, 'protocol' | 'hostname' | 'pathname' | 'search' | 'hash'>
): string | null {
  if (!canonicalHost?.startsWith('www.')) return null;
  const bare = canonicalHost.slice('www.'.length);
  if (here.hostname !== bare) return null;
  return `${here.protocol}//${canonicalHost}${here.pathname}${here.search}${here.hash}`;
}
